import * as React from 'react';
import { ReactChildrenGeneralType } from '../../../models/ReactChildrenGeneralType';

interface FlexContainerProps {
     children: ReactChildrenGeneralType;
     gap: number;
}

export function FlexContainer({
     children,
     gap
}: FlexContainerProps) {
     const style = {
          display: 'flex',
          gap: `${gap}px`
     } as any;
     return <div
          style={style}
     >
          {children}
     </div>;
}